import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['selecteds', 'options', 'option'];

  connect() {
    this.#renderSelecteds();
  }

  // action="click->multi-select#toggleOptions"
  toggleOptions() {
    const isOpen = this.optionsTarget.style.display === 'block';
    this.optionsTarget.style.display = isOpen ? 'none' : 'block';
  }

  // action="change->multi-select#optionChanged"
  optionChanged() {
    this.#renderSelecteds();
  }

  // action="click@document->multi-select#closeOnOutsideClick"
  closeOnOutsideClick({ target }) {
    if (!this.element.contains(target)) {
      this.optionsTarget.style.display = 'none';
    }
  }

  // action="keyup@window->multi-select#closeOnEscape"
  closeOnEscape({ key }) {
    if (key === 'Escape') {
      this.optionsTarget.style.display = 'none';
    }
  }

  #renderSelecteds() {
    const frag = document.createDocumentFragment();

    this.optionTargets
      .filter((option) => option.checked)
      .forEach((option) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'c-multiSelect__selected';
        button.textContent = option.dataset.label;
        button.addEventListener('click', (event) => {
          event.stopPropagation();
          option.checked = false;
          this.#renderSelecteds();
        });
        frag.appendChild(button);
      });

    this.selectedsTarget.replaceChildren(frag);
  }
}
